import type { Resource } from '../../';
export const product_sizeChart_measurements_millimeters: Resource = {"default":"mm"};
